module.exports = __webpack_public_path__ + "img/empty.441f7914.png";